import { render, staticRenderFns } from "./ProcessosAdministrativosComponent.vue?vue&type=template&id=9f2996ac&scoped=true"
import script from "./ProcessosAdministrativosComponent.vue?vue&type=script&lang=js"
export * from "./ProcessosAdministrativosComponent.vue?vue&type=script&lang=js"
import style0 from "./ProcessosAdministrativosComponent.vue?vue&type=style&index=0&id=9f2996ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2996ac",
  null
  
)

export default component.exports